import { render, staticRenderFns } from "./BkashPromotion.vue?vue&type=template&id=a99f6098&"
import script from "./BkashPromotion.vue?vue&type=script&lang=js&"
export * from "./BkashPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports